import React, { Component } from 'react'
import './EditGroup.css'
import { BtnPrimary, BtnSecondary } from '../commons/Buttons'
import { database, storage, ref, get, update, storageRef, uploadBytes, getDownloadURL } from '../../firebase'
import Loading from '../commons/Loading'
import Info from './Info.jsx'

class EditGroup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      admin: {
        name: '',
        photo: ''
      },
      title: '',
      mode: '',
      currentCover: null,
      cover: null,
      activity: null
    }
    this.getData = this.getData.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }
  componentDidMount () {
    this.getData()
      .then((data) => {
        this.setState({
          admin: data.admin,
          title: data.title,
          mode: data.mode,
          currentCover: data.cover
        })
      })
      .catch((err) => console.error(err))
  }
  getData () {
    return new Promise((resolve, reject) => {
      let admin, title, cover, mode
      get(ref(database, 'grupos/index/' + this.props.groupId))
        .then((snap) => {
          admin = snap.val().admin
          title = snap.val().titulo
          cover = snap.val().cover
          mode = snap.val().mode
          return get(ref(database, 'usuarios/index/' + admin))
        })
        .then((snap) => {
          admin = {
            name: snap.val().name,
            photo: snap.val().photo
          }
          return get(ref(database, 'quinielas/modalidades/' + mode))
        })
        .then((snap) => {
          resolve({
            admin: admin,
            title: title,
            cover: cover,
            mode: snap.val().titulo
          })
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  onSubmit () {
    this.setState({
      activity: true
    })
    this.uploadCover()
      .then((cover) => {
        return update(ref(database, 'grupos/index/' + this.props.groupId), {
          cover: cover || this.state.currentCover,
          titulo: this.state.title
        })
      })
      .then(() => {
        this.setState({
          activity: null
        })
        this.props.closeModal()
        setTimeout(() => window.location.reload(), 800)
      })
      .catch((err) => {
        console.error(err)
      })
  }
  uploadCover () {
    return new Promise((resolve, reject) => {
      if (this.state.cover) {
        this.state.cover.toBlob((blob) => {
          const coverRef = storageRef(storage, 'grupos/covers/' + this.props.groupId + '.jpg')
          uploadBytes(coverRef, blob)
            .then((snap) => {
              return getDownloadURL(storageRef(storage, snap.metadata.fullPath))
            })
            .then((url) => resolve(url))
            .catch((err) => reject(err))
        }, 'image/jpeg', 0.86)
      } else {
        resolve(null)
      }
    })
  }
  render () {
    return (
      <div className='edit-group'>
        <div className='edit-group__admin'>
          <div className='edit-group__label'>Admin</div>
          <div className='edit-group__admin__row'>
            <div className='edit-group__admin__image'>
              <img src={this.state.admin.photo} alt={this.state.admin.name} />
            </div>
            <div className='edit-group__admin__name'>{this.state.admin.name.length > 24 ? this.state.admin.name.substring(0, 24) + '...' : this.state.admin.name}</div>
          </div>
        </div>
        <Info title={this.state.title} mode={this.state.mode} current={this.state.currentCover} handleTitle={(value) => this.setState({ title: value })} handleCover={(value) => this.setState({ cover: value })} />
        <div className='edit-group__row'>
          <div className='edit-group__col'>
            <BtnSecondary onClick={() => this.props.closeModal()}>Cancelar</BtnSecondary>
          </div>
          <div className='edit-group__col'>
            <BtnPrimary onClick={() => this.onSubmit()} disabled={!this.state.title || this.state.activity}>{this.state.activity ? <Loading /> : 'Hecho'}</BtnPrimary>
          </div>
        </div>
      </div>
    )
  }
}

export default EditGroup
